'use client'

// MUI Imports
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'

// Types
interface ErrorStateProps {
  glassmorphismStyle: Record<string, any>
  error: string | null
  onRetry: () => void
}

const ErrorState = ({ glassmorphismStyle, error, onRetry }: ErrorStateProps) => {
  return (
    <Card elevation={0} sx={{ ...glassmorphismStyle }}>
      <CardContent sx={{ p: 2 }}>
        <Alert
          severity='warning'
          variant='outlined'
          sx={{ display: 'flex', alignItems: 'center' }}
          action={
            <Button color='inherit' size='small' onClick={onRetry}>
              Tentar novamente
            </Button>
          }
        >
          <Typography variant='body2'>{error || 'Erro ao carregar clima'}</Typography>
        </Alert>
      </CardContent>
    </Card>
  )
}

export default ErrorState
